import { dispatchTrackEvent } from './adapters';
import { getParameters } from './formatter';
import { EVENTS } from './core/constants';
import type { EventContext, EventName } from './types';

/**
 * Assembles tracking parameters and sends a web tracking event.
 *
 * @param event - The name of the event to track.
 * @param context - Optional context used to build event parameters; may include a `window` property that will be attached to the dispatched payload.
 * @returns The result returned by `dispatchTrackEvent` when the event is sent successfully, or the value returned by `console.error` (`undefined`) if an error occurs.
 */
async function trackWebEvent(event: EventName, context: EventContext = {}) {
  try {
    // object data to be sent
    const parameters = await getParameters(context, event);

    // function to send event
    return await dispatchTrackEvent(
      event,
      Object.assign({}, parameters, { window: context.window })
    );
  } catch (err) {
    return console.error(`[DT] Error tracking event ${event}:`, err);
  }
}

export { trackWebEvent, EVENTS };

export default {
  trackWebEvent,
  EVENTS,
}
